<template>
  <div class="download">
      <b-container>
                <b-row>
                    <b-col lg="6" md="12" sm="12" class="imageNon">
                        <img class="image" src="https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/03/CLUTCHApp.png">
                    </b-col>
                    <b-col lg="6" md="12" sm="12">
                        <div class="RightDownload">
                            <h2 class="heading">Download the Clutch Pro Tour App</h2>
                            <p class="description">
                                We’re excited to introduce the official Clutch Pro Tour App — the central hub for everything Clutch.<br><br>
                                Players can join the tour, enter tournaments, manage memberships and profiles, and access schedules, tee times and event details all in one place.<br><br>
                                For fans and spectators, the app brings Clutch closer than ever with live scoring, leaderboards, real-time tournament updates and full visibility of the season.
                            </p>
                            <div>                            
                                <b-link href="https://play.google.com/store/apps/details?id=com.ocssport.tms.tourapp.cpt" target="_blank" class="downloadLink">
                                    <img class="downloadImage rightMarg" src="https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/GooglePlay.png">
                                </b-link>
                                <b-link href="https://apps.apple.com/us/app/clutch-pro-tour/id6756672491" target="_blank" class="downloadLink">
                                    <img class="downloadImage" src="https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/AppStore.png">
                                </b-link>
                            </div>
                        </div>
                    </b-col>
                </b-row>
      </b-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Download',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            'https://wp-cpt.ocs-software.com/' + "/wp-json/wp/v2/pages/8"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.rightMarg {
    margin-right: 20px;
}
.RightDownload {
    margin-top: 1em;
}
.downloadImage {
    width: 182px;
}
.Allbuttons {
    width: 420px;
    height: 50px;
    background: transparent;
    color: #fff;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #081C3F;
    font-size: 16px;
    position: absolute;
    bottom: 0;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
    border-radius: 26px;
}
.Allbuttons:hover {
    width: 420px;
    height: 50px;
    background: #081C3F;
    color: #fff;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    position: absolute;
    bottom: 0;
    transform: translateY(-10px);
    border-radius: 26px;
}
.downloadLink:hover > .downloadImage {
    transform: translateY(-10px);
}
.downloadLink >.downloadImage {
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);    
}
.arrow {
    width: 14px;
    height: 12px;
}
.noPad {
    /* padding: 0; */
}
.download {
    background-color: #081C3F;
    padding: 10%;
    padding-bottom: 0%;
    background-image: url(https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/Flag_Background.png);
    background-repeat: no-repeat;
    background-size: contain;
    padding-top: 90px;
}
.heading {
    font-weight: 600;
    font-size: 36px;
    color: #00FFFE;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
}
/* mobile code */
.containterInside.container.mobContainer {
    padding-top: 40px;
    padding-bottom: 40px;
}
/* End of mobile code */
.description {
    text-align: left;
    margin-top: 30px;
    margin-bottom: 30px;
    color: #fff;
    font-size: 20px;
}
.space {
    margin-top: 30px;
}
.bkImageFull {
    background-color: #000000; /* For browsers that do not support gradients */
}
.containterInside {
    padding-top: 100px;
    padding-bottom: 100px;
}
h2.MainTitle {
    font-size: 28px;
    color: #9CD58A;
    font-weight: bold;
    text-align: left;
}
.image {
    /* width: 100%; */
    width: 519px;
}
p.itemsLeft::before {
    content: "";
    height: 15px;
    width: 15px;
    background-image: url(https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/Icon-ion-checkmark.png);
    background-repeat: no-repeat;
    margin-right: 10px;
    margin-top: 4px;
}
.itemsLeft {
    text-align: left;
    color: #ffffff;
    font-size: 16px;
    /* display: flex; */
    margin-bottom: 20px;
}
.SubTitle {
    color: #9CD58A;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin-top: 30px;
    margin-bottom: 20px;
}

@media only screen and (max-width: 1300px) {
    .image {
        width: 100%;
    }
}
@media only screen and (max-width: 1260px) {
    .imageNon{
        display: none;
    }
    .col-sm-12.col-md-12.col-lg-6 {
        width: 100%;
        max-width: 100%;
        flex: 0 0 100%;
        padding-bottom: 60px;
        padding-top: 20px;
    }
}
@media only screen and (max-width: 1200px) {
    .RightDownload {
        margin-top: 0;
    }
}
@media only screen and (max-width: 990px) {
    .heading {
        font-weight: 600;
        font-size: 26px;
        color: #00FFFE;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
    .downloadImage{
        width: 145px;
    }
    .image{
        display: none;
    }
    .download {
        padding-top: 0px!important
    }
    .download {
        background-color: #081C3F;
        padding: 0%;
        padding-bottom: 0%;
        background-image: none;
        background-repeat: no-repeat;
        background-size: contain;
        padding-top: 25px;
    }
    .col-sm-12.col-md-12.col-lg-6{
        width: 100%;
        max-width: 100%;
        flex: 0 0 100%;
        padding-bottom: 25px;
        padding-top: 25px;
    }
}
@media only screen and (max-width: 400px) {
    .downloadImage{
        width: 45%;
        /* margin-bottom: 10px; */
    }
}
</style>
